// Dinacharya has no survey yet — its scores will arrive from the external Google Sheets
// pipeline. Until then one indicative figure is shared by every screen so the demo stays
// consistent between the home dashboard and the Dinacharya workspace.
export const DINACHARYA_DEMO = { score10: 7.5, band: "Good" };
